<template lang="pug">
.metaContainer(v-loading="loading" element-loading-text="数据更新中...")
  .title 表单页面
  .oper
    el-button(type="primary" plain size="small" @click="addFormDialog") 新建表单页
    el-button(size="small" type="danger" :disabled="multipleSelection.length===0" @click="metaDelete") 删 除
  .list
    vxe-table(border round resizable size="medium" show-overflow keep-source
      ref="xTable" :data="tableData"
      @checkbox-all="selectAllEvent"
      @checkbox-change="selectChangeEvent"
      :edit-config="{trigger: 'manual', mode: 'row'}")
      vxe-column(type="checkbox" width="60",align="center")
      vxe-column(type="seq" width="50",align="center",title="序号")
      vxe-column(field="formName",align="center", title="表单名称" :edit-render="{}" )
        template(#edit="{ row }")
          vxe-input(v-model="row.formName" type="text" size="medium")
      vxe-column(field="formCode" ,align="center",title="表单编号" :edit-render="{}" )
        template(#edit="{ row }")
          vxe-input(v-model="row.formCode" type="text" size="medium")
      vxe-column(field="primaryMetaName",align="center", title="关联业务模型" :edit-render="{}")
        template(#default="{ row }")
          span {{ getContralName(row.primaryMetaName)}}
        template(#edit="{ row }")
          vxe-select(v-model="row.primaryMetaName" transfer size="medium")
            vxe-option(v-for="item in metaList" :key="item.tableName" :value="item.tableName" :label="item.businessName")
      vxe-column(field="remark",align="center", title="描述" :edit-render="{}" )
        template(#edit="{ row }")
          vxe-input(v-model="row.remark" type="text" size="medium")
      vxe-column(field="" ,align="center",title="操作" v-slot="{row}")
        template(v-if="$refs.xTable.isActiveByRow(row)")
          vxe-button(type="primary" size="mini" @click="saveRowEvent(row)") 保 存
          vxe-button( size="mini" @click="cancelRowEvent(row)") 取 消
        template(v-else)
          vxe-button( size="mini" status="primary" @click="editRowEvent(row)") 编 辑
          vxe-button( size="mini" type="default" @click="handleCloneForm(row)") 复 制
  compontent(:is="dataDialog" ref="dataDialog" @update="update" @initTree="initTree")
</template>

<script>
import "@/CommonDP/utils/vxe-table/index.js";
import metadataService from "@/CommonDP/service/metadata-service.js";
import detailMetaDialog from "./dialog/detailMetaDialog.vue";
import cloneFormDlg from "./dialog/cloneFormDlg.vue";
import editFormDialog from "./dialog/editFormDialog.vue";
export default {
  components: { cloneFormDlg, editFormDialog },
  data () {
    return {
      dataDialog: "",
      tableData: [],
      formData: {},
      loading: false,
      multipleSelection: [],
      metaList: []
    };
  },
  methods: {
    queryList(data) {
      this.formData = data;
      this.queryDynMetaListByGroupID();
    },
    // 获取业务模型列表
    async queryDynMetaListByGroupID() {
      this.loading = true;
      const res = await metadataService.queryDynMetaListByGroupID(this.formData.groupId);
      this.metaList = res.data || [];
      this.dynFormList();
    },
    // 获取列表
    async dynFormList() {
      const res = await metadataService.dynFormList(this.formData.groupId);
      this.tableData = res.data || [];
      this.loading = false;
    },
    selectAllEvent ({ checked }) {
      const records = this.$refs.xTable.getCheckboxRecords();
      this.multipleSelection = records;
    },
    selectChangeEvent({ checked }) {
      const records = this.$refs.xTable.getCheckboxRecords();
      this.multipleSelection = records;
    },
    initTree() {
      // this.queryDynMetaListByGroupID();
      this.$emit("initTree");
    },
    async saveRowEvent ({ formId, formCode, remark, formName, formGroupId, formGroupName, primaryMetaName }) {
      const params = {
        formId, formName, formGroupId, formGroupName, primaryMetaName, formCode, remark,
        isPublish: 0,
        otherMetaNames: '',
        stdFormName: '',
        flowKey: ''
      };
      await metadataService.dynFormUpdate(params);
      this.$success("操作成功");
      const $table = this.$refs.xTable;
      $table.clearActived();
    },
    cancelRowEvent (row) {
      const $table = this.$refs.xTable;
      $table.clearActived().then(() => {
        // 还原行数据
        $table.revertData(row);
      });
    },
    metaDelete() {
      this.$confirm(`确认删除选中的数据吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async() => {
        this.loading = true;
        const batchIdList = this.multipleSelection.map(e => e.formId);
        await metadataService.dynFormDelete(batchIdList);
        this.$emit('initTree');
        this.queryDynMetaListByGroupID();
        this.$success("操作成功");
        this.loading = false;
      }).catch((error) => {
        console.log(error);
      });
    },
    // 更新统计表数据
    update() {
      this.queryDynMetaListByGroupID();
    },
    addFormDialog() {
      this.$emit('openTypeDialog', this.formData, "addForm");
    },
    // 业务模型详情
    async showDetailRow(row) {
      this.dataDialog = detailMetaDialog;
      await this.$nextTick();
      this.$refs.dataDialog.openDialog(row.metaId, row.businessName);
    },
    getContralName(enName) {
      return this.metaList.find(e => e.tableName === enName)?.businessName;
    },
    // 编辑
    async editRowEvent (row) {
      this.dataDialog = editFormDialog;
      await this.$nextTick();
      this.$refs.dataDialog.editForm(row);
      // const $table = this.$refs.xTable;
      // $table.setActiveRow(row);
    },
    // 复制
    async handleCloneForm(row) {
      this.dataDialog = cloneFormDlg;
      await this.$nextTick();
      this.$refs.dataDialog.show(row);
    }
  }

};
</script>

<style lang="scss" scoped>
.metaContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  .title {
    border-bottom: 1px solid rgba(211, 217, 232, 0.77);
    padding: 10px 0;
    line-height: 25px;
    color: var(--key-color);
    font-weight: 600;
    font-size: 16px;
  }

  .oper {
    padding: var(--middle-space) 0;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .list{
    height: calc(100% - 80px);
    overflow-y: auto;
  }
}

/deep/.vxe-table--render-default.vxe-editable .vxe-body--column,
.vxe-table--render-default.vxe-editable .vxe-body--column.col--actived {
  padding: 11px 0
}
</style>

